<template>
  <div class="customer-item">
    <div class="header">
      <span class="name">{{ company.companyName || (company.approveInfo && company.approveInfo.name) }}<span style="font-size: 12px; color: #9d9d9d;">({{ company.subSellerName }})</span></span>
      <span v-if="company.lastAccessDate" class="access-info">{{ company.salerName }}&nbsp;于&nbsp;{{ company.lastAccessDate | dateFmt }}拜访过</span>
      <el-button type="text" style="padding: 3px 0; margin-left: 6px; font-size: 14px;" @click="modal('AccessLogModal', company.id, company.companyName)">拜访日志</el-button>
    </div>
    <!--如果未认证并且有待认证信息-->
    <div v-if="company.state === 1 && company.approveInfo" class="unapprove-status" data-uac="customer.approve$$客户管理.资料审核">
      <el-button type="warning" size="mini" @click="doApprove">去审核</el-button>
    </div>
    <div class="row">
      <div class="field col-sm-6" data-uac="customer.fullphone$$客户管理.显示完整手机号">
        <label>主账号</label>
        <div v-if="company.approveState === 1 && company.approveInfo">
          {{ phoneShow(company.approveInfo.userName) }}
        </div>
        <div v-else>
          {{ phoneShow(company.userName) }}({{ company.passportName }})
        </div>
      </div>
      <div class="field col-sm-6">
        <label>账号</label>
        <div>
          <el-button type="text" size="mini" @click="handleShowPassport">{{ company.passportCount }}</el-button>
        </div>
      </div>
      <div class="field col-sm-6">
        <label>状态</label>
        <div>{{ statusName[company.status] }}</div>
      </div>
      <div class="field col-sm-6">
        <label>最后活跃</label>
        <div v-if="company.lastActiveTime">{{ company.lastActiveTime | dateTimeFmt }}</div>
        <div v-else>30天内无活跃</div>
      </div>
    </div>
    <div class="row">
      <div class="field col-sm-12">
        <label>地址</label>
        <div v-if="company.approveState === 1 && company.approveInfo">
          {{ [company.approveInfo.province, company.approveInfo.city, company.approveInfo.area, company.approveInfo.address].filter(t => t).join(' ') }}
        </div>
        <div v-else>
          {{ [company.province, company.city, company.area, company.address].filter(t => t).join(' ') }}
        </div>
      </div>
      <div class="field col-sm-6">
        <label>服务消费</label>
        <div>
          <el-button type="text" size="mini" :disabled="!company.serviceTotalAmount" @click="handleShowServiceHistory">
            {{ company.serviceTotalAmount | currencyFmt }}
          </el-button>
          <el-button type="text" size="mini" @click="handleShowQueryLog">
            查询记录
          </el-button>
        </div>
      </div>
      <div class="field col-sm-6">
        <label>当前服务</label>
        <div v-if="company.buyed">
          <el-button type="text" size="mini" @click="handleShowServiceNow">{{ company.buyed | buyedFmt }}</el-button>
          <span style="color: #c9c9c9">(到期时间：{{ company.expirationTime | dateFmt }})</span>
        </div>
        <div>
          <span style="color: #c9c9c9; text-decoration: line-through;">{{ company.expirationTime | dateFmt }}已到期</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="field col-sm-6">
        <label>下单次数</label>
        <div>{{ company.orderTimes }}</div>
      </div>
      <div class="field col-sm-6">
        <label>下单金额</label>
        <div>
          <el-button type="text" size="mini" :disabled="!company.partOrderTotalAmount" @click="handleShowPartOrder">
            {{ company.partOrderTotalAmount - company.partOrderReturnAmount | currencyFmt }}
          </el-button>
        </div>
      </div>
      <div class="field col-sm-6">
        <label>下单时间</label>
        <div v-if="company.lastBuyTime">{{ company.firstBuyTime | dateFmt }}-{{ company.lastBuyTime | dateFmt }}</div>
        <div v-else>--</div>
      </div>
      <div class="field col-sm-6">
        <label>购买品牌</label>
        <div>{{ company.brands || '--' }}</div>
      </div>
    </div>
    <div v-if="company.activityInfo && company.activityInfo.id" style="margin-top: 4px; width: auto;">
      <div style="width: auto;">
        <el-popover trigger="hover" placement="right">
          <div>
            <div style="color: #000; font-size: bold;">{{ company.activityInfo.name }}</div>
            <div>活动时间:{{ company.activityInfo.startTime | dateFmt }}~{{ company.activityInfo.endTime | dateFmt }}</div>
            <div v-for="detail in company.activityInfo.details" :key="detail.key">
              {{ detail.key }}: {{ detail.value | currencyFmt }}
            </div>
          </div>
          <span slot="reference" style="color: #000; cursor: pointer;">{{ company.activityInfo.name }}：累计：<b>{{ company.activityInfo.totalAmount | currencyFmt }}</b></span>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CustomerItem',
  filters: {
    buyedFmt (val) {
      if (!val) {
        return '--'
      } else {
        let bs = val.split(',')
        const buyedTypes = ['1', '2', '3', '8']
        if (bs.find(s => ~buyedTypes.indexOf(s))) {
          return '已购买'
        } else if (bs.indexOf('4') > -1) {
          return '体验包'
        }
      }
    }
  },
  props: {
    company: {
      type: Object,
      default () {
        return {
          id: undefined,
          identityNo: '',
          companyName: '',
          phone: '',
          userName: '',
          passportName: '',
          lastActiveTime: '',
          province: '',
          city: '',
          area: '',
          address: '',
          approveState: 1,
          status: 1,
          approvingInfo: null,
          partOrderTotalAmount: 0,
          partOrderReturnAmount: 0,
          passportCount: 1,
          serviceAmount: 0.00,
          buyed: ''
        }
      }
    }
  },
  data () {
    return {
      statusName: [
        '',
        '正常',
        '禁用'
      ]
    }
  },
  methods: {
    handleShowPassport () {
      this.modal('PassportModal', this.company.id).promise.catch(() => {})
    },
    handleShowServiceHistory () {
      this.modal('ServiceOrderHistoryModal', this.company.id).promise.catch(() => {})
    },
    handleShowServiceNow () {
      this.modal('ServiceOrderNowModal', this.company.id).promise.catch(() => {})
    },
    handleShowQueryLog () {
      this.modal('QueryLogModal', this.company.id).promise.catch(() => {})
    },
    doApprove () {
      this.modal('ApproveModal',
        this.company.approveInfo
      ).promise.then(() => {
        this.$emit('reload')
      })
    },
    handleShowPartOrder () {
      this.modal('PartOrderStatisticModal', this.company.id).promise.catch(() => {})
    }
  }
}
</script>
